import { render, staticRenderFns } from "./LanguageDefinition.vue?vue&type=template&id=3a477484&"
import script from "./LanguageDefinition.vue?vue&type=script&lang=js&"
export * from "./LanguageDefinition.vue?vue&type=script&lang=js&"
import style0 from "./LanguageDefinition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports